// src/components/SearchFooter.ts
import "./SearchFooter.css";

export function renderSearchFooter(container: HTMLElement): void {
  const year = new Date().getFullYear();

  container.innerHTML = `
    <footer class="search-footer" aria-label="AyeSearch footer">
      <div class="search-footer-inner">
        <div class="search-footer-brand-row">
          <a class="search-footer-brand" href="/">AyeSearch</a>
          <span class="search-footer-copy">© ${year} AyeSearch</span>
        </div>

        <nav class="search-footer-links" aria-label="Search footer links">
          <a href="/about">About</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/search">Search</a>
        </nav>
      </div>
    </footer>
  `;
}
